import { render, staticRenderFns } from "./UserAuthorizationCheckCode.vue?vue&type=template&id=beac7406&scoped=true&"
import script from "./UserAuthorizationCheckCode.vue?vue&type=script&lang=js&"
export * from "./UserAuthorizationCheckCode.vue?vue&type=script&lang=js&"
import style0 from "./UserAuthorizationCheckCode.vue?vue&type=style&index=0&id=beac7406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beac7406",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('beac7406')) {
      api.createRecord('beac7406', component.options)
    } else {
      api.reload('beac7406', component.options)
    }
    module.hot.accept("./UserAuthorizationCheckCode.vue?vue&type=template&id=beac7406&scoped=true&", function () {
      api.rerender('beac7406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/UserAuthorization/components/common/UserAuthorizationCheckCode.vue"
export default component.exports